import React from 'react';
import { Pill } from '../aiinterview/recruiter/common';

const PROVIDER = { microsoft: 'Outlook', google: 'Google' };

export const syncMeta = (s) => {
  if (!s) return null;
  if (s.status === 'synced') return { tone: 'green', label: `Synced to ${PROVIDER[s.provider] || 'calendar'}` };
  if (s.status === 'failed') return { tone: 'red', label: 'Sync failed' };
  return { tone: 'slate', label: 'Invite emailed (.ics)' };
};

// Where a booked interview's invite went: the organizer's Outlook/Google calendar, or .ics email only.
export const SyncBadge = ({ b, testId }) => {
  const m = b.status === 'scheduled' ? syncMeta(b.calendar_sync) : null;
  if (!m) return null;
  const tip = b.calendar_sync.status === 'failed' ? b.calendar_sync.error : undefined;
  return <Pill tone={m.tone} testId={testId} title={tip}>{m.label}</Pill>;
};

export default SyncBadge;
